import { render } from "./MessagesPage.vue?vue&type=template&id=6bfebc2a&scoped=true"
import script from "./MessagesPage.vue?vue&type=script&lang=js"
export * from "./MessagesPage.vue?vue&type=script&lang=js"

import "./MessagesPage.vue?vue&type=style&index=0&id=6bfebc2a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfebc2a"]])

export default __exports__